import * as React from 'react';
import { observable } from 'mobx';

import { ProductProviderDataService } from 'src/app/products/product-providers/product-provider.data';
import { DropdownView } from 'src/core/ui/dropdown.view';
import { SearchType } from 'src/app/products/contractSimulator/parts/pax-occupancy.view';

interface IProps {
	required?: boolean;
	textProperty?: string;
	label?: string;
	type: SearchType;
	multi?: boolean;
	mode: ControlMode;
	value: number | number[] | null;
	alternativeKey?: string;
	onChange?: (services: ProductProviderItem[]) => void;
}

export default class SeachServiceProviderEditor extends React.Component<IProps, any>{
	
	@observable
	private dataService: ProductProviderDataService;

	constructor(props) {
		super(props);

		this.dataService = ProductProviderDataService.make();
	}

	public componentDidMount() {
		this.loadServices();
	}

	filterBaseOnType = () => {

		switch (this.props.type) {
			case 'Accommodation':
				this.dataService.addFilter('isActiveForAccommodation', 'eq', true);
				break;

			case 'CarRent':
				this.dataService.addFilter('isActiveForCarRent', 'eq', true);
				break;

			case 'Transfer':
				this.dataService.addFilter('isActiveForTransfer', 'eq', true);
				break;
			case 'General':
				this.dataService.addFilter('isActiveForGeneral', 'eq', true);
				break;

			case 'Flights':
				this.dataService.addFilter('isActiveForFlight', 'eq', true);
				break;
		}

	}

	loadServices = async () => {

		
	}

	serviceQuery = (q?: string): Promise<QueryResult<ProductProviderItem>> => {
		return new Promise<QueryResult<ProductProviderItem>>((resolve, reject) => {
			this.dataService.addFilter('isDeleted', 'eq', false);
			this.filterBaseOnType();

			this.dataService.searchKeywords = q;
			this.dataService.addSorting('id', 'asc', true);
			this.dataService.load(query => query)
				.then((items) => {
					resolve({
						items: items,
						totalCount: this.dataService.count
					});
				});
		});
	};


	render() {
		if (!this.dataService)
			return null;

		return (
			<DropdownView
				required={this.props.required}
				request={{ query: this.serviceQuery, dataSet: this.dataService } as any}
				multi={this.props.multi}
				label={this.props.label}
				model={this.props.value}
				keyField={this.props.alternativeKey || "id"}
				disabled={this.props.mode == 'display'}
				textField={this.props.textProperty || 'apiName'}
				onChanged={this.props.onChange}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/shared/product-search-service-providers.editor.tsx